// @flow

import React from 'react';

import FormNode from 'app/get-help/components/Form/Node';

import type { Node } from 'react';

import type { FormActions } from 'app/get-help/components/Form/types';
import type { SelectedNode } from 'app/get-help/utils/tree/types';
import type { States } from 'app/get-help/components/Form/machine';

type Props = {
  actions: FormActions,
  nodes: SelectedNode[],
  state: States,
};

const Help = ({ actions, nodes, state }: Props): Node => {
  const helpNode = nodes[nodes.length - 1];

  return (
    <FormNode
      actions={actions}
      key={helpNode.pathId}
      node={helpNode}
      state={state}
    />
  );
};

export default Help;
